<template>
  <div
    v-if="legendItems.length"
    class="legend-list"
  >
    <div
      v-for="item in legendItems"
      :key="item"
      class="legend-item"
    >
      <div class="legend-box" />
      <span class="legend-text">{{ item }}</span>
      <div class="legend-value" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoughnutSkeletonLegend',
  props: {
    legendItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="less" scoped>
.legend-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 15px;
  min-width: 180px;
  width: 180px;
}

.legend-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  width: 100%;
}

.legend-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: @grey-400;
  margin-right: 8px;
}

.legend-text {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: @grey-500;
}

.legend-value {
  width: 28px;
  height: 16px;
  border-radius: 6px;
  background-color: @grey-400;
  margin-left: 20px;
}
</style>
